import config from '@/config'
import { httpClientPrivate } from '@/libs/httpClient'
import { useQuery } from '@tanstack/react-query'

export interface IncidentStatusOption {
  code: string | null
  name: string
}

interface IncidentStatusResponse {
  status: IncidentStatusOption[]
}

const fetchFilterIncidentStatus = async (): Promise<IncidentStatusOption[]> => {
  const response = await httpClientPrivate.get<IncidentStatusResponse>(
    `${config.restUrl}/v1/backoffice/crash-detection/incident-status`,
  )
  return response.data.status
}

const useFilterIncidentStatus = () => {
  const queryKey = ['useFilterIncidentStatus']
  const queryFn = async () => fetchFilterIncidentStatus()
  const queryResult = useQuery({ queryKey, queryFn })

  return { ...queryResult }
}

export { fetchFilterIncidentStatus, useFilterIncidentStatus }
